/**
 * As a motion component's `onUpdate`, keeps motion running the animation
 * itself rather than handing it to the browser (WAAPI): in Chrome that
 * animation ends a frame before motion writes the final value, so a faded
 * element flashes back to where it started for that frame.
 */
export const keepAnimationInJs = () => {};
